import { MouseEventHandler, useCallback, useRef } from 'react';

const DEFAULT_TIMEOUT = 300;

export const useDoubleClick = ({
    onClick,
    onDoubleClick,
    timeout = DEFAULT_TIMEOUT,
}: {
    onClick?: MouseEventHandler;
    onDoubleClick?: MouseEventHandler;
    timeout?: number;
}): MouseEventHandler => {
    const timerRef = useRef<number | null>(null);
    const onElemClick: MouseEventHandler = useCallback(
        (e) => {
            if (timerRef.current === null) {
                timerRef.current = window.setTimeout(() => {
                    onClick?.(e);
                    timerRef.current = null;
                }, timeout);
            } else {
                window.clearTimeout(timerRef.current);
                timerRef.current = null;
                onDoubleClick?.(e);
            }
            e.preventDefault();
        },
        [onClick, onDoubleClick, timeout]
    );

    return onElemClick;
};
